export default __webpack_public_path__ + "static/media/avatar-7.92f12188.png";